<template>
  <section
    class="entry-layout"
    style="height: 100vh; min-width: 1200px"
  >
    <entry-layout-header
      v-if="isAuthStore"
      :favorites="favorites"
      :menus="menus"
      :subMenus="subMenus"
      :customTabs="customTabs"
      :customMenus="customMenus"
      :activeKey="activeKey"
      :currentLang="currentLang"
      :panesHistory="panesHistory"
      :class="{ 'disable-click': $refs['ErpEmptyModalRef']?.disableClick }"
      @menusadd="handleAddCustomMenus"
      @menuschange="handleMenusChange"
      @menuchange="handleMenuChange"
      @custommenu="handleEditCustomMenus"
      @viewall="handleViewAll"
    >
      <slot
        name="rightContentRender"
        slot="rightContentRender"
      ></slot>
    </entry-layout-header>
    <entry-guide-header v-else></entry-guide-header>

    <section class="entry-layout">
      <entry-multi-tab
        v-show="isAuthStore"
        :favorites="favorites"
        :menus="menus"
        :panes="panes"
        :activeKey="activeKey"
        :currentLang="currentLang"
        :class="{ 'disable-click': $refs['ErpEmptyModalRef']?.disableClick }"
        @change="handleMenuChange"
        ref="multiTab"
      />
      <!-- 跑马灯 -->
      <ticker class="entry-ticker-bar"></ticker>
      <!-- 主体 -->
      <entry-layout-content v-show="isAuthStore">
        <slot></slot>
      </entry-layout-content>
      <entry-guide-content v-if="!isAuthStore"></entry-guide-content>
      <!-- erp到期提示 -->
      <erpModal></erpModal>
      <!-- erp单量为0提示，替代路由的erp单量401拦截 -->
      <erp-empty-modal v-if="isAuthStore" ref="ErpEmptyModalRef"></erp-empty-modal>
    </section>
  </section>
</template>

<script>
import EntryLayoutHeader from './EntryLayoutHeader'
import EntryLayoutContent from './EntryLayoutContent'
import EntryMultiTab from './EntryMultiTab'
import Ticker from '@/components/Tips/NewsTicker'
import erpModal from '@/components/Tips/erpModal'
import ErpEmptyModal from '@/components/Tips/ErpEmptyModal.vue'
import EntryGuideHeader from '../GuideLayout/EntryGuideHeader.vue'
import EntryGuideContent from '../GuideLayout/EntryGuideContent.vue'

export default {
  name: 'EntryLayout',
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    menus: {
      type: Array,
      default: () => []
    },
    subMenus: {
      type: Array,
      default: () => []
    },
    customMenus: {
      type: Array,
      default: () => []
    },
    customTabs: {
      type: [Array, Array],
      default: () => [[], []]
    },
    menusActiveID: {
      type: String,
      default: ''
    },
    panes: {
      type: Array,
      default: () => []
    },
    panesHistory: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  components: {
    EntryLayoutHeader,
    EntryLayoutContent,
    EntryMultiTab,
    Ticker,
    erpModal,
    ErpEmptyModal,
    EntryGuideHeader,
    EntryGuideContent
  },
  computed: {
    // 用户是否授权店铺
    isAuthStore() {
      return this.$store.getters.guidePageProcess?.process?.platform_user === 1
    }
  },
  methods: {
    // 新增自定义菜单
    handleAddCustomMenus() {
      if (this.$store.getters.isDemo) {
        this.$message.warning(this.$t('layouts.demo.tips'))
        return
      }
      this.$emit('addcustommenu')
    },
    // 删除自定义菜单
    handleRemoveCustomMenus(menu) {
      this.$emit('removecustommenu', menu)
    },
    // 修改自定义菜单
    handleEditCustomMenus(menu) {
      this.$emit('editcustommenu', menu)
    },
    // 显示菜单组
    handleMenusChange(key) {
      this.$emit('menuschange', key)
    },
    /**
     *  切换子菜单
     * @param[key] String - menuId
     * @param[record] Objecgt - { statisticsType, searchKey }
     */
    handleMenuChange(key, record = {}) {
      this.$emit('menuchange', { key, ...record })
    },
    // 钉一下，置顶菜单
    handleMenuPushpin(e) {
      this.$emit('menupushpin', e)
    },
    handleViewAll() {
      this.$refs.multiTab.visible = true
    }
  }
}
</script>

<style lang="less">
.entry-layout {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
  overflow: hidden;
}

.entry-layout.entry-layout--has-sider {
  flex-direction: row;
}

.disable-click {
  pointer-events: none;
}
</style>
